// @LTG-ID: data-industry-multiples
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 04b_SHARED_CONTRACT.md, 08_FEATURES.md#F-010, source_reference_v3_pending/README.md §"Sector → data validation" (lines 242-298), Landing Page.html (v3) lines 1487-1497
// @CHANGED: 2026-05-24 session_005 (CHG-0076, ORCH-0073) — v3 reconciliation: 11 of 12 upper bounds raised + 3 driver-string refinements (SaaS unchanged)
// @OWNER: web
//
// Industry-multiple lookup table. Ported from /app/source_reference_v3_pending/
// Landing Page.html lines 1487-1497 (v3). v3 README §1.10.a documents the audit
// against research-doc sources (Profitability Partners 2025, Bain Healthcare PE
// 2025, FOCUS 2026, GF Data Q1 2025, etc.). Numbers must be refreshed quarterly
// in production per README §"Source provenance and quarterly refresh".
// Consumed by Snapshot calculator in P2; SECTORS records reference these keys.

export const INDUSTRY_MULTIPLES = {
    saas: {
        label: "SaaS / Software",
        low: 4.8,
        high: 7.2,
        basis: "Revenue",
        driver: "ARR & gross retention",
    },
    prof_services: {
        label: "Professional Services",
        low: 2.8,
        high: 5.5,
        basis: "EBITDA",
        driver: "Owner dependency",
    },
    manufacturing: {
        label: "Manufacturing",
        low: 3.2,
        high: 8.0,
        basis: "EBITDA",
        driver: "Customer concentration & certs",
    },
    construction: {
        label: "Trades & Construction",
        low: 3.2,
        high: 9.0,
        basis: "EBITDA",
        driver: "Recurring service mix",
    },
    healthcare: {
        label: "Healthcare Practices",
        low: 4.0,
        high: 12.0,
        basis: "EBITDA",
        driver: "Payor mix & specialty",
    },
    ecommerce: {
        label: "E-commerce / DTC",
        low: 2.8,
        high: 5.5,
        basis: "EBITDA",
        driver: "Repeat-purchase rate",
    },
    financial: {
        label: "Financial Services",
        low: 3.4,
        high: 8.5,
        basis: "EBITDA",
        driver: "AUM stickiness",
    },
    retail: {
        label: "Retail",
        low: 2.0,
        high: 3.6,
        basis: "EBITDA",
        driver: "Location quality",
    },
    restaurants: {
        label: "Restaurants & Food",
        low: 2.1,
        high: 6.0,
        basis: "EBITDA",
        driver: "Format & unit count",
    },
    auto: {
        label: "Auto & Transportation",
        low: 2.5,
        high: 5.5,
        basis: "EBITDA",
        driver: "Owner-as-tech gap",
    },
    personal: {
        label: "Personal Services",
        low: 1.8,
        high: 4.0,
        basis: "EBITDA",
        driver: "Owner dependency",
    },
    childcare: {
        label: "Childcare & Education",
        low: 2.5,
        high: 6.0,
        basis: "EBITDA",
        driver: "Licensing transferability",
    },
};
